var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Layout',[_c('Header',{style:({background:_vm.navBackground})},[_c('app-header')],1),_c('Content',[_c('router-view')],1),_c('Footer',[_c('app-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }